module.exports = __webpack_public_path__ + "media/images/emoticons/wobbly-ab8b8c0eacafd3654d613cdd30a54501.gif";